import type { RocketReaderPlanet } from '@/data/rocketReaderChallenges';

type PlanetProgressProps = {
  planets: RocketReaderPlanet[];
  currentPlanetIndex: number;
};

export function PlanetProgress({ planets, currentPlanetIndex }: PlanetProgressProps) {
  return (
    <section className="rr-panel rr-planets-panel" aria-label="Planet progress">
      <div className="rr-panel-heading">
        <span>Planet path</span>
        <strong>
          {currentPlanetIndex + 1}/{planets.length}
        </strong>
      </div>
      <ol className="rr-planet-list">
        {planets.map((planet, index) => {
          const isCurrent = index === currentPlanetIndex;
          const isUnlocked = index <= currentPlanetIndex;

          return (
            <li
              key={planet.name}
              className={`rr-planet-step${isCurrent ? ' rr-planet-step-current' : ''}${
                isUnlocked ? ' rr-planet-step-unlocked' : ''
              }`}
              aria-current={isCurrent ? 'step' : undefined}
            >
              <span
                className="rr-planet-dot"
                style={{ background: planet.color, boxShadow: `0 0 18px ${planet.accent}` }}
                aria-hidden="true"
              />
              <span>{planet.name}</span>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
